var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckOn = function SvgCheckOn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.107,
    height: 13.107,
    viewBox: "0 0 13.107 13.107",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M519.808,1072.122a6.553,6.553,0,1,0,6.553,6.553A6.55,6.55,0,0,0,519.808,1072.122Zm3.469,4.763-4.2,4.2a.437.437,0,0,1-.618,0l-2.122-2.122a.437.437,0,0,1,.618-.618l1.813,1.813,3.89-3.889a.437.437,0,0,1,.618.618Z",
    transform: "translate(-513.255 -1072.122)",
    fill: "#91dc1b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckOn, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy4xMDciIGhlaWdodD0iMTMuMTA3IiB2aWV3Qm94PSIwIDAgMTMuMTA3IDEzLjEwNyI+DQogIDxwYXRoIGlkPSJQYXRoXzYzNiIgZGF0YS1uYW1lPSJQYXRoIDYzNiIgZD0iTTUxOS44MDgsMTA3Mi4xMjJhNi41NTMsNi41NTMsMCwxLDAsNi41NTMsNi41NTNBNi41NSw2LjU1LDAsMCwwLDUxOS44MDgsMTA3Mi4xMjJabTMuNDY5LDQuNzYzLTQuMiw0LjJhLjQzNy40MzcsMCwwLDEtLjYxOCwwbC0yLjEyMi0yLjEyMmEuNDM3LjQzNywwLDAsMSwuNjE4LS42MThsMS44MTMsMS44MTMsMy44OS0zLjg4OWEuNDM3LjQzNywwLDAsMSwuNjE4LjYxOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTMuMjU1IC0xMDcyLjEyMikiIGZpbGw9IiM5MWRjMWIiLz4NCjwvc3ZnPg0K";
export { ForwardRef as ReactComponent };